<a mat-list-item [ngStyle]="{'padding-left': (depth * 12) + 'px'}" (click)="onItemSelected(item)"
   [ngClass]="{'active': item.route ? router.isActive(item.route, true): false, 'expanded': item.expanded}"
   class="menu-list-item" *ngIf="item.visible" [hidden]="item.hidden" >
  <!--mat-icon class="routeIconSvg" [svgIcon]="item.svgIconName" *ngIf="item.svgIconName != null"></mat-icon>
  <mat-icon class="routeIcon" *ngIf="item.svgIconName == null">{{item.iconName}}</mat-icon-->
    <div class="menu-list-item-detail">
      <generic-icon class="routeIconSvg" *ngIf="item.svgIconName != null" [iconName]="item.svgIconName != null ? item.svgIconName : item.iconName" [type]="item.svgIconName != null?'custom':'google'"></generic-icon>
      <generic-icon class="routeIcon" *ngIf="item.svgIconName == null"   [iconName]="item.svgIconName != null ? item.svgIconName : item.iconName" [type]="item.svgIconName != null?'custom':'google'"></generic-icon>
      {{('menu.'+item.id|translateTA)}}
    
      <span fxFlex *ngIf="item.children && item.children.length" >
        <span fxFlex id="aaa"></span>
        <mat-icon [@indicatorRotate]="item.expanded ? 'expanded': 'collapsed'">
          expand_more
        </mat-icon>
      </span>
    </div>
</a>
<div *ngIf="item.expanded">
  <app-menu-list-item *ngFor="let child of item.children" [item]="child" [depth]="depth+1">
  </app-menu-list-item>
</div>
